import CustomTable from '../../../../elements/Table/CustomTable'
import React from 'react'

function DeliveryOrderLinesList(props) {
  const { list, fetch, fetching, onShow } = props

  const columns = [
    {
      Header: 'ID',
      accessor: '_id',
      width: 250,
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Sales ID',
      accessor: 'salesLine._id',
      width: 250,
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'No',
      accessor: 'no',
      width: 150,
      Cell: ({ value, original }) => <a onClick={() => onShow(original, 'edit')}>{value}</a>,
    },
    {
      Header: 'Name',
      accessor: 'name',
      style: { alignment: 'left', marginLeft: 10 },
    },

    { Header: 'Total Units', accessor: 'unit', width: 150 },
    { Header: 'Units Requisitioned', accessor: 'requisitioned', width: 150 },
    { Header: 'Units Purchased', accessor: 'purchased', width: 150 },
    { Header: 'Units Ready', accessor: 'ready', width: 150 },
    {
      Header: 'Units in Transit',
      accessor: 'package',
      width: 150,
      Cell: ({ value }) => {
        const confirmed = value ? value.filter((p) => ['Delivered', 'Confirmed'].includes(p.status)) : []
        return confirmed.map((p) => p.unit).reduce((acc, v) => v + acc, 0)
      },
    },
    {
      Header: 'Units Delivered',
      accessor: 'delivered',
      width: 150,
    },
  ]

  return (
    <CustomTable
      data={list}
      defaultPageSize={20}
      isFilterable={true}
      fetching={fetching}
      fetch={fetch}
      columns={columns}
    />
  )
}

DeliveryOrderLinesList.propTypes = {}
DeliveryOrderLinesList.defaultProps = {}

export default DeliveryOrderLinesList
